import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import cn from 'classnames';

import classes from './modal.module.scss';
import { IModal } from './types';

const Modal: React.FC<IModal> = ({ className, isOpen, onClose, children }) => {

	const onKeyDown = (event: KeyboardEvent): void => {
		if (event?.key?.toLowerCase() === 'escape') {
			onClose();
		}
	};

	useEffect(() => {
		document.addEventListener('keydown', onKeyDown);
		return () => {
			document.removeEventListener('keydown', onKeyDown);
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (!isOpen) return null;

	const modal = (
		<div className={classes.modal}>
			<div className={classes.overlay} onClick={onClose} />
			<div className={cn(classes.container, className)}>
				{children}
			</div>
		</div>
	)

	return ReactDOM.createPortal(modal, document.body);
};

export default Modal;